app.CouponList = app.AbstractCollection.extend({
  model: app.Coupon,

  url() {
    return '/api/v2/coupons';
  },
});
